import { apiRequestFactory } from "@/api/util";

const apiSpec = {
  "/participation/proposal/public/list": {
    required: ["projectId"],
    listResponse: "proposals",
    attachToResponseItems: ["projectId"],
  },
};

const apiRequest = apiRequestFactory(apiSpec);

export default {
  list: (options) => apiRequest(options, "/participation/proposal/public/list"),
};
